/* 机构本身相关 关于我们*/
/* keepAlive:该页面是否缓存 */
export default [
    {
        path: 'group/about',
        name: 'groupAbout',
        meta: {
            title: '关于我们',
            // isShowTab: false,
        },
        component: () => import('@/views/group/about.vue')
    },
    {
        path: 'group/app',
        name: 'groupApp',
        meta: {
            title: '',
            // isShowTab: false,
        },
        component: () => import('@/views/group/app.vue')
    },
     {
        path: 'group/liveApp',
        name: 'groupLiveApp',
        meta: {
            title: '',
            // isShowTab: false,
        },
        component: () => import('@/views/group/liveApp.vue')
    },
]